var MenuItemsModel = /** @class */ (function () {
    function MenuItemsModel() {
    }
    return MenuItemsModel;
}());
export { MenuItemsModel };
